import gsap from 'gsap'

export function setUpBlade2bAnimation () {
  gsap.set('.large-quotes', {alpha: 0})
  gsap.set('#blade2b .quote-text', {alpha: 0})
  gsap.set('.custom-citation', {alpha: 0})
}

export function blade2banimation () {
  const obj1 = {
    alpha: 0,
    delay: 2.7, 
    duration: 1.5,
    x: '50%',
  }

  const obj2 = {
    alpha: 0,
    delay: 0.5, 
    duration: 2.5,
    y: '-300%',
  }

  const obj3 = {
    alpha: 0,
    delay: 1, 
    duration: 3,
    y: '200%',
  }

  gsap.set('.large-quotes', {alpha: 1})
  gsap.set('#blade2b .quote-text', {alpha: 1})
  gsap.set('.custom-citation', {alpha: 1})
  
  gsap.from('.large-quotes', obj2)
  gsap.from('#blade2b .quote-text', obj3)
  gsap.from('.custom-citation', obj1)
  
  gsap.to('#shale-quote', 3, { opacity: 1})

  if(window.innerWidth >= 576){
    gsap.set('#shale-quote',{backgroundSize:"100%", backgroundPosition:"center"})

    gsap.from('#shale-quote', 3, {
      backgroundSize: "200%",
      backgroundPosition: "center", 
      autoRound:false, 
      ease: "Power1.ease0ut"
    })
  }
}